<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                           <multiselect v-model="param_cst"
                           :options="optionsParamCst"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="CST"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                           <multiselect v-model="tp_imposto"
                           :options="optionsParamTipoImposto"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Tipo Imposto"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                           <multiselect v-model="tp_regra"
                           :options="optionsLivTpRegra"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Tipo Regra"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                           <multiselect v-model="tp_doc"
                           :options="optionsTpDoc"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Tipo Documento"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                    </b-col>
                    <b-col sm="8" md="4" class="p-a-0 m-t-5px">
                      <multiselect v-model="cliente"
                      :options-limit="300"
                      :limit="2"
                      :limit-text="limitText"
                      :options="optionsCliente"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Cliente ( Digite ao menos 3 caracteres, CNPJ, CPF, CUIT, Nome ou Razão Social )"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      :searchable="true"
                      :loading="isLoadingExp"
                      @search-change="listaClientesCliente"
                      ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  data () {
    return {
      isLoadingExp: false,
      helpForm: new Form({params: [], search:''}),
      cd: '',
      descr: '',
      optionsLivStatus: [],
      status: [],
      optionsParamCst: [],
      param_cst: [],
      optionsLivTpRegra: [],
      tp_regra: [],
      optionsParamTipoImposto: [],
      tp_imposto: [],
      optionsTpDoc: [],
      tp_doc: [],
      optionsCliente: [],
      cliente: [],
      data_filter: []
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              descr: this.descr,
                              status: this.status,
                              param_cst: this.param_cst,
                              tp_regra: this.tp_regra,
                              tp_imposto: this.tp_imposto,
                              tp_doc: this.tp_doc,
                              cliente: this.cliente}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.descr = '';
        this.status = '';
        this.param_cst = '';
        this.tp_regra = '';
        this.tp_imposto = '';
        this.tp_doc = '';
        this.cliente = '';
        this.$events.fire('filter-reset');
      },
      listaClientesCliente(search) {
          if(search.length>=3)
          {
              this.helpForm.search = search;
              this.helpForm.post('/api/pessoa/jsonlist').then(response =>
              {
                  this.optionsCliente = [];
                  new ReturnApi(response, this, true, false, false);
                  this.isLoadingExp = true;
                  response.items.forEach((obj)=>
                  {
                    this.optionsCliente.push({ label: " PJ - "+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                  });
                  response.itemsF.forEach((obj)=>
                  {
                    this.optionsCliente.push({ label: " PF - "+obj.pessoa.cd+" - "+obj.nome+" - "+obj.cpf, value: obj.pessoa_id })
                  });
                  response.itemsE.forEach((obj)=>
                  {
                    this.optionsCliente.push({ label: " PE - "+obj.pessoa.cd+" - "+obj.nome+" - "+obj.cuit, value: obj.pessoa_id })
                  });
                  this.isLoadingExp = false;
              })
              .catch(errors =>
              {
                  new ReturnApi(errors, this)
              });
          }
      },
      getLivGeral()
      {
          this.helpForm.get('/api/regrafiscal/jsonlistgeralfiltros').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.cst.forEach((obj)=>
              {
                  this.optionsParamCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id })
              })
              response.tp_regra.forEach((obj)=>
              {
                  this.optionsLivTpRegra.push({ label: obj.descr, value: obj.valor })
              })
              response.tp_imposto.forEach((obj)=>
              {
                  this.optionsParamTipoImposto.push({ label: obj.descr, value: obj.partipimp_id })
              })
              response.tp_doc.forEach((obj)=>
              {
                  this.optionsTpDoc.push({ label: obj.descr, value: obj.partipdoc_id })
              })
              response.status.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      limitText (count) {
        return ' e ${count} outros clientes'
      },
      onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
      {
          var cnpj_formatado
          var pad = "00000000"
          var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
          var pad = "0000"
          var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
          var pad = "00"
          var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

          return cnpj_base+""+cnpj_filial+""+cnpj_digito;
      }
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
